import React from "react";
import { CiCircleRemove } from "react-icons/ci";
import loader from "../../assets/loader.gif";
export interface IParentForm {
  email: string;
  name: string;
  phone: number;
  relationship: string;
  phone_number: any;
  home_number: any;
  onChange?: (event: any) => void;
  onAction?: () => void;
  index?: any;
  validateLoading?: string;
  existingParents?: any[] | undefined;
  selectedParent?: any;
  setSelectedParent?: any;
  parentId?: any;
  parentIdArray?: string[];
  setParentIdArray?: any;
  isParentExist?: any[];
  setIsParentExist?: any[];
  newExistingData?: any;
  setNewSelected?: any;
  newSelected?: string[];
}

export const ParentForm = ({
  email,
  name,
  relationship,
  phone,
  home_number,
  onChange,
  index,
  onAction,
  isParentExist,
  validateLoading,
  newExistingData,
  newSelected = [],
  setNewSelected,
}: any) => {
  return (
    <div>
      <div className="border rounded-md px-4 py-10 mx-3 mb-6 relative">
        {/* EMAIL */}
        <div className="mt-4">
          <h4>
            Email <span className="text-red-600">*</span>
          </h4>

          <input
            type="email"
            name="email"
            value={email}
            onChange={onChange}
            required
            className="w-full mt-2 border rounded p-2"
          />

          {/* LOADING */}
          {validateLoading?.toLowerCase() === "loading" ? (
            <div className="flex gap-2 items-center mt-2">
              <img src={loader} className="w-4 h-4" />
              <p className="text-xs">checking...</p>
            </div>
          ) : (
            isParentExist?.[index]?.status && (
              <div className="mt-3 space-y-2">
                <p className="text-xs text-green-700">Parent Found:</p>

                {newExistingData[index]?.map((item: any) => {
                  const isSelected = newSelected.includes(item.id);

                  return (
                    <div
                      key={item.id}
                      className={`p-3 border rounded flex justify-between items-center
                      ${
                        isSelected ? "bg-green-50 border-green-400" : "bg-white"
                      }`}
                    >
                      <p className="font-medium">{item.name}</p>

                      <button
                        onClick={(e) => {
                          e.preventDefault();

                          setNewSelected((prev: any) =>
                            prev.includes(item.id)
                              ? prev.filter((id: any) => id !== item.id)
                              : [...prev, item.id],
                          );
                        }}
                        className={`px-3 py-1 rounded text-xs transition
                        ${
                          isSelected
                            ? "bg-green-900 text-white"
                            : "bg-green-700 text-white"
                        }`}
                      >
                        {isSelected ? "Selected!" : "Click to Select"}
                      </button>
                    </div>
                  );
                })}
              </div>
            )
          )}
        </div>

        {/* OTHER FORM */}
        {!isParentExist?.[index]?.status && (
          <>
            <div className="mt-4">
              <h4>
                Name <span className="text-red-600">*</span>
              </h4>
              <input
                name="name"
                value={name}
                onChange={onChange}
                className="w-full mt-2 border rounded p-2"
              />
            </div>

            <div className="mt-4">
              <h4>
                Mobile Number <span className="text-red-600">*</span>
              </h4>
              <input
                name="phone"
                value={phone}
                onChange={onChange}
                className="w-full mt-2 border rounded p-2"
                required
              />
            </div>

            <div className="mt-4">
              <h4>Other Phones</h4>
              <input
                name="home_number"
                value={home_number}
                onChange={onChange}
                className="w-full mt-2 border rounded p-2"
              />
            </div>

            <div className="mt-4">
              <h4>
                Relation <span className="text-red-600">*</span>
              </h4>

              <div className="flex gap-2 mt-2">
                {["Parent", "Guardian"].map((r) => (
                  <div
                    key={r}
                    onClick={() =>
                      onChange({
                        target: { name: "relationship", value: r },
                      })
                    }
                    className={`px-3 py-2 border rounded cursor-pointer
                    ${relationship === r ? "bg-green-800 text-white" : ""}`}
                  >
                    {r}
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {/* REMOVE */}
        {index > 0 && (
          <CiCircleRemove
            className="absolute top-3 right-3 text-red-500 text-2xl cursor-pointer"
            onClick={onAction}
          />
        )}
      </div>
    </div>
  );
};
